import { Stack } from "@mui/material";
import * as React from "react";
import { BranchLimitControl } from "./BranchLimitControl";
import { ReservesFilterControl } from "./ReservesFilterControl";
import { useReservesSearch } from "./pages/search/Reserves/ReservesSearchProvider";

export interface ReservesOptionsParameters {
  branchFilters: string[];
  targetAudience: string;
  department: string;
  course: string;
  instructor: string;
}

export interface ReservesDepartmentOption {
  name: string;
  value: string;
  comment: string;
}
export interface ReservesCourseOption {
  name: string;
  value: string;
  comment: string;
}
export interface ReservesInstructorOption {
  value: string;
  name: string;
  displayName: string;
}

export interface ReserveOptions {
  departments: ReservesDepartmentOption[];
  courses: ReservesCourseOption[];
  instructors: ReservesInstructorOption[];
}

export interface ReservesOptionsReturn {
  success: boolean;
  options: ReserveOptions;
}

export interface ReservesSearchFormProps {
  //add props here
}

export const ReservesSearchForm: React.FC<ReservesSearchFormProps> = () => {
  const {
    searchParams: { department, course, instructor },
    setDepartment,
    setCourse,
    setInstructor,
    setBranchFilters,
  } = useReservesSearch();

  return (
    <Stack sx={{ gap: 2 }}>
      <BranchLimitControl
        onChangeBranchLimits={(newBranchIdentifiers) => {
          setBranchFilters(newBranchIdentifiers);
        }}
      ></BranchLimitControl>

      <ReservesFilterControl
        department={department}
        instructor={instructor}
        course={course}
        onChangeCourse={(newCourse) => setCourse(newCourse)}
        onChangeDepartment={(newDepartment) => setDepartment(newDepartment)}
        onChangeInstructor={(newInstructor) => setInstructor(newInstructor)}
      ></ReservesFilterControl>
    </Stack>
  );
};
